import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceInsights = () => {
  const insights = [
    {
      type: 'positive',
      title: 'Revenue Growth',
      description: 'Monthly revenue increased by 23.8% compared to last month',
      icon: 'TrendingUp',
      action: 'View Details'
    },
    {
      type: 'neutral',
      title: 'Peak Hours',
      description: 'Most plays occur between 7-9 PM EST',
      icon: 'Clock',
      action: 'Optimize Schedule'
    },
    {
      type: 'warning',
      title: 'User Retention',
      description: 'Average session time decreased by 5.2% this week',
      icon: 'Users',
      action: 'Improve Engagement'
    },
    {
      type: 'positive',
      title: 'Top Performer',
      description: 'Space Quest generated 35% of total revenue',
      icon: 'Star',
      action: 'Promote Game'
    }
  ];

  const demographics = [
    { region: 'North America', percentage: 45, color: 'bg-blue-500' },
    { region: 'Europe', percentage: 30, color: 'bg-green-500' },
    { region: 'Asia', percentage: 20, color: 'bg-yellow-500' },
    { region: 'Others', percentage: 5, color: 'bg-gray-500' }
  ];

  const getInsightColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-green-600 bg-green-50';
      case 'warning':
        return 'text-yellow-600 bg-yellow-50';
      case 'negative':
        return 'text-red-600 bg-red-50';
      default:
        return 'text-blue-600 bg-blue-50';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Performance Insights</h2>
        <button className="flex items-center space-x-2 px-4 py-2 bg-muted text-muted-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm">
          <Icon name="RefreshCw" size={16} />
          <span>Refresh</span>
        </button>
      </div>

      <div className="space-y-4 mb-6">
        {insights.map((insight, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 bg-muted/20 rounded-lg">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${getInsightColor(insight.type)}`}>
              <Icon name={insight.icon} size={16} />
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-foreground mb-1">{insight.title}</h3>
              <p className="text-sm text-muted-foreground mb-2">{insight.description}</p>
              <button className="text-sm text-primary hover:text-primary/80 transition-colors font-medium">
                {insight.action}
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="border-t border-border pt-6">
        <h3 className="font-medium text-foreground mb-4">Geographic Distribution</h3>
        <div className="space-y-3">
          {demographics.map((demo, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className={`w-3 h-3 rounded-full ${demo.color}`} />
                <span className="text-sm text-foreground">{demo.region}</span>
              </div>
              <span className="text-sm font-medium text-foreground">{demo.percentage}%</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 p-4 bg-accent/5 rounded-lg border border-accent/20">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Lightbulb" size={16} className="text-accent" />
          <span className="text-sm font-medium text-accent">Recommendation</span>
        </div>
        <p className="text-sm text-muted-foreground">
          Consider launching targeted campaigns in Europe and Asia to capitalize on growing markets and increase revenue potential.
        </p>
      </div>
    </div>
  );
};

export default PerformanceInsights;